module.exports = __webpack_public_path__ + "assets/img/bg-22ed7441.png";